/**
 * /comparison. Comparison is part of the AI assessments (the same plan feature as governance, risk and
 * compliance). Enterprise accounts go to their comparison page inside the enterprise shell, as before;
 * every other plan that includes the feature opens it, and a plan without it sees the upgrade message
 * the other assessment pages show, instead of being sent to Chat with no reason given.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useBilling } from '../../context/BillingContext';
import FeatureGate from '../billing/components/FeatureGate';
import { EnterpriseRoute } from '../enterprise/components/EnterpriseRoute';
import { ComparisonPage } from './ComparisonPage';

export const ComparisonRoute: React.FC = () => {
  const { subscription } = useBilling();
  if (subscription?.plan_tier === 'enterprise') {
    return (
      <EnterpriseRoute>
        <Navigate to="/enterprise/dashboard/comparison" replace />
      </EnterpriseRoute>
    );
  }
  return (
    <FeatureGate feature="advanced_ai" fallbackTitle="Comparison requires an upgrade">
      <ComparisonPage />
    </FeatureGate>
  );
};

export default ComparisonRoute;
